<template>
  <div>
    <Pane />
    <a-card class="container">
      <!-- 顶部操作栏 -->
      <div class="header-wrapper">
        <a-row type="flex" justify="space-between" align="middle">
          <a-col :span="16">
            <a-space>
              <a-button-group>
                <a-button icon="left" @click="prevMonth" />
                <a-month-picker
                  v-model="selectedMonth"
                  placeholder="选择年月"
                  @change="onMonthChange"
                  style="width: 150px"
                />
                <a-button icon="right" @click="nextMonth" />
              </a-button-group>
              <a-select
                v-model="selectedWeek"
                placeholder="选择周"
                style="width: 130px"
                @change="onWeekChange"
              >
                <a-select-option v-for="item in weekOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-input
                addon-before="填报人"
                :value="userName"
                style="width: 200px"
                disabled
              />
              <a-input
                addon-before="部门"
                :value="deptName"
                style="width: 200px"
                disabled
              />

            </a-space>
          </a-col>
          <a-col :span="8" style="text-align: right">
            <a-space>
              <a-button icon="export" @click="handleReuseLastWeek">
                复用上周
              </a-button>
              <ContractSelector @change="onContractSelect">
                <a-button type="primary" icon="plus">
                  添加项目
                </a-button>
              </ContractSelector>
            </a-space>
          </a-col>
        </a-row>
      </div>

      <!-- 数据表格 -->
      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :scroll="{ x: 'max-content' }"
        :rowKey="(record, index) => record.id || index"
      >
        <a-table-column title="项目编码" data-index="code" width="150px" />
        <a-table-column title="项目名称" data-index="contractName" width="180px" />
        <a-table-column title="回款记录" width="250px">
          <template slot-scope="text, record">
            <div v-if="record.collectionRecordList && record.collectionRecordList.length">
              <div v-for="(item, index) in record.collectionRecordList" :key="index">
                {{ item.amount }} ({{ item.date ? item.date.substring(0, 10) : '-' }})
              </div>
              <div style="border-top: 1px solid #e8e8e8; margin-top: 4px; padding-top: 4px; font-weight: bold;">
                合计: {{ getCollectionTotal(record) }} 元 ({{ record.collectionRecordList.length }}笔)
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="需支付分包商" width="180px">
          <template slot-scope="text, record">
            <a-select
              v-model="record.subpackageName"
              placeholder="请选择分包"
              style="width: 100%"
              @change="onSubpackageChange(record)"
            >
              <a-select-option v-for="item in record.subpackageOptions" :key="item.id" :value="item.name">
                {{ item.name }} - {{ item.companyName }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="需分包分包金额(元)" width="160px">
          <template slot-scope="text, record">
            <a-input 
              :value="record.payableAmount" 
              @change="(e) => record.payableAmount = Number(e.target.value) || 0"
            />
          </template>
        </a-table-column>
        <a-table-column title="已支付分包(元)" width="140px">
          <template slot-scope="text, record">
            <a-input 
              :value="record.paidAmount" 
              @change="(e) => record.paidAmount = Number(e.target.value) || 0"
            />
          </template>
        </a-table-column>
        <a-table-column title="剩余应支付分包(元)" width="170px" align="right">
          <template slot-scope="text, record">
            <span style="font-weight: bold; color: #f5222d;">{{ ((record.payableAmount || 0) - (record.paidAmount || 0)).toFixed(2) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="备注" width="150px">
          <template slot-scope="text, record">
            <a-input v-model="record.remark" />
          </template>
        </a-table-column>
        <a-table-column title="操作" width="100px" fixed="right">
          <template slot-scope="text, record">
            <a @click="handleDelete(record)">删除</a>
          </template>
        </a-table-column>
      </a-table>

      <!-- 保存按钮 -->
      <div v-if="list.length > 0" style="margin-top: 16px; text-align: center">
        <a-button type="primary" :loading="saving" @click="saveData">
          保存
        </a-button>
      </div>

      <!-- 日历表格 -->
      <div v-if="weekColumns.length > 0" style="margin-top: 16px">
        <a-card title="月度日历" :bordered="false" size="small">
          <table style="width: 100%; border-collapse: collapse; font-size: 12px">
            <thead>
              <tr style="background: #f5f5f5">
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%">周一</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%">周二</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%">周三</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%">周四</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%">周五</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%; color: #999">周六</th>
                <th style="padding: 8px; border: 1px solid #e8e8e8; text-align: center; width: 14.28%; color: #999">周日</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(week, weekIndex) in calendarWeeks" :key="weekIndex">
                <td 
                  v-for="(day, dayIndex) in week" 
                  :key="dayIndex"
                  :style="{
                    padding: '8px',
                    border: '1px solid #e8e8e8',
                    textAlign: 'center',
                    backgroundColor: day.isCurrentMonth ? (day.isWeekend ? '#fff9f9' : '#fff') : '#f9f9f9',
                    color: day.isCurrentMonth ? (day.isWeekend ? '#999' : '#333') : '#ccc'
                  }"
                >
                  <div v-if="day.day">
                    <div style="font-weight: bold">{{ day.day }}</div>
                    <div v-if="day.weekNumber" style="font-size: 10px; color: #1890ff">第{{ day.weekNumber }}周</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </a-card>
      </div>
    </a-card>
  </div>
</template>

<script>
import { batchSaveSubpackagePaymentPlan, calculatePaymentAmount, getWeeks, generateCollectionJson, getDeptWeekPlan } from "@/api/finance/subpackage-payment-plan";
import { fetchContractDetail } from "@/api/finance/payment";
import { mapGetters } from "vuex";
import ContractSelector from "@/components/contract-selector";
import moment from "moment";

export default {
  components: {
    ContractSelector,
  },
  data() {
    return {
      userName: "",
      deptId: "",
      deptName: "",
      selectedMonth: null,
      currentMonth: "",
      selectedWeek: undefined,
      list: [],
      loading: false,
      saving: false,
      weekColumns: [],
      calendarWeeks: [],
    };
  },

  computed: {
    ...mapGetters("auth", ["department"]),
    yearMonth() {
      if (this.selectedMonth) {
        return moment(this.selectedMonth).format("YYYY-MM");
      }
      return this.currentMonth;
    },
    weekOptions() {
      return this.weekColumns.map((item) => ({
        label: `第${item.weekNumber}周`,
        value: item.weekNumber,
      }));
    },
  },

  created() {
    this.userName = this.$store.state.auth?.user?.employeeVo?.name || "";
    this.deptId = this.$store.state.auth?.user?.employeeVo?.deptId || "";
    this.deptName = this.$store.state.auth?.user?.employeeVo?.deptName || "";

    this.initCurrentMonth();
    this.generateWeekColumns();
  },

  methods: {
    // 初始化当前月
    initCurrentMonth() {
      const now = new Date();
      this.currentMonth = moment(now).format("YYYY-MM");
      this.selectedMonth = moment(this.currentMonth, "YYYY-MM");
      this.selectedWeek = undefined;
    },

    // 年月选择变化
    onMonthChange(date) {
      this.selectedMonth = date;
      this.generateWeekColumns();
    },

    // 周选择变化
    onWeekChange() {
      this.loadCurrentWeekPlan();
    },

    // 复用上周
    handleReuseLastWeek() {
      if (!this.selectedWeek || this.selectedWeek <= 1) {
        this.$message.warning('当前已是第一周，无法复用上周');
        return;
      }

      const [year, month] = this.yearMonth.split('-');
      const prevWeek = this.selectedWeek - 1;

      this.loading = true;
      getDeptWeekPlan({
        year,
        month: parseInt(month),
        weekNumber: prevWeek,
      })
        .then((res) => {
          if (res && Array.isArray(res) && res.length > 0) {
            const reusedList = res.map((item) => ({
              id: null,
              year: year,
              month: parseInt(month),
              weekNumber: this.selectedWeek,
              contractId: item.contractId,
              contractName: item.contractName,
              code: item.contractCode,
              collectionRecordList: item.collectionRecordList || [],
              subpackageName: item.subpackageName || '',
              subpackageOptions: [],
              payableAmount: item.payableAmount || 0,
              paidAmount: item.paidAmount || 0,
              remainingAmount: item.remainingAmount || 0,
              remark: item.remark || '',
            }));

            reusedList.forEach((plan) => {
              this.loadSubpackageList(plan);
            });

            this.list = reusedList;
            this.$message.success('复用成功');
          } else {
            this.$message.info('上周无数据可复用');
          }
        })
        .catch((err) => {
          this.$message.error('复用失败：' + (err.message || '未知错误'));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 进入时加载当前周数据
    loadCurrentWeekPlan() {
      if (!this.selectedWeek) return;

      const [year, month] = this.yearMonth.split('-');

      this.loading = true;
      this.list = [];
      getDeptWeekPlan({
        year,
        month: parseInt(month),
        weekNumber: this.selectedWeek,
      })
        .then((res) => {
          if (res && Array.isArray(res) && res.length > 0) {
            const list = res.map((item) => ({
              id: item.id,
              year: year,
              month: parseInt(month),
              weekNumber: this.selectedWeek,
              contractId: item.contractId,
              contractName: item.contractName,
              code: item.contractCode,
              collectionRecordList: item.collectionRecordList || [],
              subpackageName: item.subpackageName || '',
              subpackageOptions: [],
              payableAmount: item.payableAmount || 0,
              paidAmount: item.paidAmount || 0,
              remainingAmount: item.remainingAmount || 0,
              remark: item.remark || '',
            }));

            list.forEach((plan) => {
              this.loadSubpackageList(plan);
            });

            this.list = list;
          }
        })
        .catch((err) => {
          this.$message.error('获取数据失败：' + (err.message || '未知错误'));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 生成周列
    generateWeekColumns() {
      getWeeks(this.yearMonth)
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.weekColumns = res.map((week) => ({
              weekNumber: week.weekNumber,
              title: `第${week.weekNumber}周`,
              dateRange: week.dateRange,
              startDate: week.startDate,
              endDate: week.endDate,
            }));
            if (this.weekColumns.length > 0) {
              const today = new Date();
              const currentWeek = this.weekColumns.find(w => {
                const start = new Date(w.startDate);
                const end = new Date(w.endDate);
                return today >= start && today <= end;
              });
              this.selectedWeek = currentWeek ? currentWeek.weekNumber : this.weekColumns[0].weekNumber;
            }
            this.generateCalendarWeeks();
            this.loadCurrentWeekPlan();
          }
        })
        .catch((err) => {
          this.$message.error("获取周信息失败：" + (err.message || "未知错误"));
        });
    },

    // 合同选择
    onContractSelect(contract) {
      const newPlan = {
        id: null,
        yearMonth: this.yearMonth,
        code: contract.code,
        contractName: contract.name,
        contractId: contract.id,
        collectionRecordList: [],
        subpackageName: '',
        subpackageOptions: [],
        payableAmount: 0,
        paidAmount: 0,
        remainingAmount: 0,
        remark: '',
      };

      this.$set(this.list, this.list.length, newPlan);
      this.$message.success('添加成功');

      this.fetchCollectionRecords(newPlan);
      this.loadSubpackageList(newPlan);
    },

    // 获取分包列表
    loadSubpackageList(plan) {
      fetchContractDetail(plan.contractId).then((res) => {
        if (res && res.projects && res.projects.length > 0 && res.projects[0].subPackages) {
          const allSubpackages = res.projects[0].subPackages.map(item => ({
            id: item.id,
            name: item.name,
            companyName: item.companyName,
          }));
          // 过滤掉同一合同下其他记录已选择的分包
          const selectedNames = this.list
            .filter(item => item.contractId === plan.contractId && item !== plan && item.subpackageName)
            .map(item => item.subpackageName);
          const subpackageOptions = allSubpackages.filter(item => !selectedNames.includes(item.name));
          this.$set(plan, 'subpackageOptions', subpackageOptions);
        }
      }).catch(() => {});
    },

    // 获取回款记录
    fetchCollectionRecords(plan) {
      generateCollectionJson({ contractId: plan.contractId })
        .then((res) => {
          if (res && Array.isArray(res)) {
            plan.collectionRecordList = res;
          }
        })
        .catch((err) => {
          this.$message.error('获取回款记录失败：' + (err.message || '未知错误'));
        });
    },

    // 计算回款记录总金额
    getCollectionTotal(record) {
      if (!record.collectionRecordList || !record.collectionRecordList.length) return 0;
      return record.collectionRecordList.reduce((sum, item) => sum + (item.amount || 0), 0);
    },

    // 分包选择变化，更新同合同其他记录的分包选项，并回显付款金额
    onSubpackageChange(record) {
      this.list.forEach(item => {
        if (item.contractId === record.contractId && item !== record) {
          fetchContractDetail(item.contractId).then((res) => {
            if (res && res.projects && res.projects.length > 0 && res.projects[0].subPackages) {
              const allSubpackages = res.projects[0].subPackages.map(sub => ({
                id: sub.id,
                name: sub.name,
                companyName: sub.companyName,
              }));
              const selectedNames = this.list
                .filter(l => l.contractId === item.contractId && l !== item && l.subpackageName)
                .map(l => l.subpackageName);
              this.$set(item, 'subpackageOptions', allSubpackages.filter(sub => !selectedNames.includes(sub.name)));
            }
          });
        }
      });

      const selected = record.subpackageOptions.find(item => item.name === record.subpackageName);
      if (selected && record.contractId) {
        calculatePaymentAmount({
          contractId: record.contractId,
          subpackageId: selected.id,
        }).then((res) => {
          if (res) {
            this.$set(record, 'payableAmount', res.payableAmount || 0);
            this.$set(record, 'paidAmount', res.paidAmount || 0);
            this.$set(record, 'collectionRecordList', res.collectionRecordList || []);
            this.$set(record, 'remark', res.remark || '');
          }
        }).catch((err) => {
          this.$message.error('获取付款金额失败：' + (err.message || '未知错误'));
        });
      }
    },

    // 删除记录
    handleDelete(record) {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除该记录吗？',
        onOk: () => {
          const index = this.list.findIndex(item => item.id === record.id);
          if (index > -1) {
            this.list.splice(index, 1);
            this.$message.success('删除成功');
            // 删除后更新同合同其他记录的分包选项
            if (record.subpackageName) {
              this.list.forEach(item => {
                if (item.contractId === record.contractId) {
                  this.loadSubpackageList(item);
                }
              });
            }
          }
        },
      });
    },

    // 保存数据
    saveData() {
      this.saving = true;

      const [year, month] = this.yearMonth.split("-");

      const dataList = this.list.map((plan) => {
        const selectedSubpackage = plan.subpackageOptions.find(item => item.name === plan.subpackageName);
        return {
          id: plan.id,
          year: year,
          month: parseInt(month),
          weekNumber: this.selectedWeek,
          contractId: plan.contractId,
          deptId: this.deptId,
          deptName: this.deptName,
          subpackageId: selectedSubpackage ? selectedSubpackage.id : null,
          subpackageNameSnapshot: selectedSubpackage ? `${selectedSubpackage.name} - ${selectedSubpackage.companyName}` : plan.subpackageName,
          payableAmount: plan.payableAmount || 0,
          paidAmount: plan.paidAmount || 0,
          collectionRecordsList: plan.collectionRecordList || [],
          remark: plan.remark,
        };
      });

      batchSaveSubpackagePaymentPlan(dataList)
        .then(() => {
          this.$message.success("保存成功");
          this.$router.push({
            path: "/finance/subpackage-payment-plan",
            query: {
              yearMonth: this.yearMonth,
            },
          });
        })
        .catch((err) => {
          this.$message.error("保存失败：" + (err.message || "未知错误"));
        })
        .finally(() => {
          this.saving = false;
        });
    },

    // 生成日历表格
    generateCalendarWeeks() {
      const [year, month] = this.yearMonth.split("-").map(Number);
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      
      const firstDayOfWeek = firstDay.getDay();
      
      const startDay = new Date(firstDay);
      if (firstDayOfWeek !== 1) {
        const daysToSubtract = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
        startDay.setDate(startDay.getDate() - daysToSubtract);
      }
      
      const endDay = new Date(lastDay);
      const lastDayOfWeek = lastDay.getDay();
      if (lastDayOfWeek !== 0) {
        const daysToAdd = 7 - lastDayOfWeek;
        endDay.setDate(endDay.getDate() + daysToAdd);
      }
      
      const weeks = [];
      let currentDay = new Date(startDay);
      
      while (currentDay <= endDay) {
        const week = [];
        for (let i = 0; i < 7; i++) {
          const dayOfMonth = currentDay.getDate();
          const isCurrentMonth = currentDay.getMonth() === month - 1;
          const dayOfWeek = currentDay.getDay();
          const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
          
          let weekNumber = null;
          if (isCurrentMonth) {
            for (const weekInfo of this.weekColumns) {
              const startDate = new Date(weekInfo.startDate);
              const endDate = new Date(weekInfo.endDate);
              if (currentDay >= startDate && currentDay <= endDate) {
                weekNumber = weekInfo.weekNumber;
                break;
              }
            }
          }
          
          week.push({
            day: dayOfMonth,
            isCurrentMonth: isCurrentMonth,
            isWeekend: isWeekend,
            weekNumber: weekNumber,
          });
          
          currentDay.setDate(currentDay.getDate() + 1);
        }
        weeks.push(week);
      }
      
      this.calendarWeeks = weeks;
    },

    // 上个月
    prevMonth() {
      const [year, month] = this.yearMonth.split("-").map(Number);
      const prevMonthDate = new Date(year, month - 2, 1);
      this.selectedMonth = moment(prevMonthDate);
      this.generateWeekColumns();
    },

    // 下个月
    nextMonth() {
      const [year, month] = this.yearMonth.split("-").map(Number);
      const nextMonthDate = new Date(year, month, 1);
      this.selectedMonth = moment(nextMonthDate);
      this.generateWeekColumns();
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px;
}

.header-wrapper {
  padding: 16px 0;
}
</style>
